export const PRODUCT_MODIFICATION_TAB_CREATED = 'PRODUCT_MODIFICATION_TAB_CREATED' as const;
export const PRODUCT_MODIFICATION_FORM_REQUESTED = 'PRODUCT_MODIFICATION_FORM_REQUESTED' as const;
export const PRODUCT_MODIFICATION_RELOAD_FORM_REQUESTED = 'PRODUCT_MODIFICATION_RELOAD_FORM_REQUESTED' as const;
export const PRODUCT_MODIFICATION_FORM_RECEIVED = 'PRODUCT_MODIFICATION_FORM_RECEIVED' as const;
export const PRODUCT_MODIFICATION_FORM_REQUEST_FAILED = 'PRODUCT_MODIFICATION_FORM_REQUEST_FAILED' as const;
export const PRODUCT_MODIFICATION_FORM_REQUEST_TIMED_OUT = 'PRODUCT_MODIFICATION_FORM_REQUEST_TIMED_OUT' as const;

export const PRODUCT_MODIFICATION_FIGHTING_BACK_COMMENT_CHANGED =
  'PRODUCT_MODIFICATION_FIGHTING_BACK_COMMENT_CHANGED' as const;
export const PRODUCT_MODIFICATION_FIGHTING_BACK_JUSTIFICATION_CHANGED =
  'PRODUCT_MODIFICATION_FIGHTING_BACK_JUSTIFICATION_CHANGED' as const;

export const PRODUCT_MODIFICATION_PUBLIC_OFFERING_DISCLAIMER_CONFORMATION_CHANGED =
  'PRODUCT_MODIFICATION_PUBLIC_OFFERING_DISCLAIMER_CONFORMATION_CHANGED' as const;
export const PRODUCT_MODIFICATION_APPLY_REQUESTED = 'PRODUCT_MODIFICATION_APPLY_REQUESTED' as const;
export const PRODUCT_MODIFICATION_APPLY_REQUEST_FAILED = 'PRODUCT_MODIFICATION_APPLY_REQUEST_FAILED' as const;
export const PRODUCT_MODIFICATION_RESULT_RECEIVED = 'PRODUCT_MODIFICATION_RESULT_RECEIVED' as const;
export const PRODUCT_MODIFICATION_RESULT_FAILED = 'PRODUCT_MODIFICATION_RESULT_FAILED' as const;
